const Dictionary = {
  MAIN_TITLE: 'COVID-19 TRACKER',
  WORLDWIDE: 'Worldwide',
  CASES: 'Cases',
  RECOVERED: 'Recovered',
  DEATHS: 'Deaths',
  CORONAVIRUS_CASES: 'Coronavirus Cases',
  LIVE_CASES_BY_COUNTRY: 'Live Cases by Country',
  WORLDWIDE_NEW: 'Worldwide new',
  TOTAL: 'Total',
};

export default Dictionary;
